(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["limitedmx-inapp-browser"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.getElementById('lmx-inapp');
    if (!box) return;
    var ua = navigator.userAgent || '';
    var inApp = /FBAN|FBAV|Instagram|Line\//i.test(ua);
    if (inApp) box.hidden = false;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lmx-tool-tracking"] && !Shopify.designMode) return;
  try {
    (function () {
  var root = document.getElementById('lmx-tool-tracking');
  if (!root) return;

  var customerId = root.getAttribute('data-customer-id') || 'guest';
  var storageKey = 'lmx_tool_usage_' + customerId;
  var PATH_TO_TOOL = {
    '/pages/semitonos-master': 'semitonos-master',
    '/pages/pedreria': 'pedreria-pro',
    '/pages/semitonos-studio': 'semitonos-studio',
    '/pages/mezzotinta-studio-ai': 'mezzotinta-studio',
    '/pages/textures-studio': 'texture-studio',
    '/pages/generador-textos': 'generador-textos',
    '/pages/sticker-studio': 'sticker-studio',
    '/pages/auditor-de-grosor': 'auditor-grosor',
    '/pages/arma-tu-metro-dtf': 'arma-metro',
    '/pages/separador-dtf-a-vinil': 'separador-dtf-a-vinil',
    '/pages/analizador-disenos-dtf': 'analizador-dtf',
    '/pages/recolorizador-dtf': 'recolorizador',
    '/pages/delineador': 'delineador',
    '/pages/semitransparencias': 'semitransparencias',
    '/pages/calculadora-de-precios-dtf': 'calculadora-dtf',
    '/pages/verificador-de-archivos-para-dtf': 'verificador-archivos',
    '/pages/separacion-de-colores-serigrafia': 'separacion-colores',
    '/pages/mallas-para-serigrafia': 'mallas-serigrafia',
    '/pages/mezclador-de-colores': 'mezclador-colores',
    '/pages/estilo-chrome': 'estilo-chrome',
    '/pages/estilo-collage': 'estilo-collage',
    '/pages/estilo-grunge': 'estilo-grunge',
    '/pages/estilo-mosaico': 'estilo-mosaico',
    '/pages/estilo-neon': 'estilo-neon',
    '/pages/estilo-puff': 'estilo-puff',
    '/pages/marco-desgastado': 'marco-desgastado',
    '/pages/only-you': 'only-you',
    '/pages/only-you-v2': 'only-you-v2',
    '/pages/only-you-plantillas': 'only-you-plantillas',
    '/pages/album-artistas': 'album-artistas',
    '/pages/flyer': 'flyer-creator',
    '/pages/promo-maker': 'promo-maker',
    '/pages/mejorador-de-imagenes-ai': 'mejorador-ia',
    '/pages/remover-fondo': 'remover-fondo',
    '/pages/mejorar-colores': 'mejorar-colores',
    '/pages/mejorador-ai-version-anterior': 'mejorador-clasico',
    '/pages/rgb-a-cmyk-1': 'rgb-cmyk',
    '/pages/vectorizador': 'vectorizador',
    '/pages/tamano-de-imagen': 'tamano-imagen',
    '/pages/pdf-a-png-1': 'pdf-png',
    '/pages/png-a-jpg': 'png-jpg',
    '/pages/svg-a-png': 'svg-png',
    '/pages/recortador-inteligente': 'recortador-inteligente',
    '/pages/recortador': 'recortador',
    '/pages/reducir-bordes': 'reducir-bordes',
    '/pages/generador-qr': 'generador-qr',
    '/pages/dorsales-futbol': 'dorsales-futbol',
    '/pages/mockups-semiautomaticos': 'mockups-semi',
    '/pages/mockups-acid-wash': 'mockups-acid-wash',
    '/pages/mockups-3d-playeras': 'mockups-3d',
    '/pages/catalogo-playeras': 'catalogo-playeras',
    '/pages/cotizador-de-playeras': 'cotizador',
    '/pages/generador-de-etiquetas-1': 'etiquetas',
    '/pages/creador-disenos-gym': 'creador-disenos-gym'
  };

  function loadState() {
    try {
      return JSON.parse(localStorage.getItem(storageKey)) || { tools: {}, lastAt: null, lastSlug: null, total: 0 };
    } catch (e) {
      return { tools: {}, lastAt: null, lastSlug: null, total: 0 };
    }
  }

  function saveState(state) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (e) {}
  }

  function currentToolSlug() {
    var path = window.location.pathname.replace(/\/$/, '') || '/';
    return PATH_TO_TOOL[path] || PATH_TO_TOOL[window.location.pathname] || null;
  }

  function publish(eventType, toolSlug, extra) {
    if (!toolSlug) return;
    var payload = {
      user_id: customerId === 'guest' ? null : customerId,
      tool_slug: toolSlug,
      event_type: eventType,
      created_at: new Date().toISOString()
    };
    if (extra) {
      payload.detail = extra;
    }
    var state = loadState();
    if (!state.tools[toolSlug]) {
      state.tools[toolSlug] = { opened: 0, uploaded: 0, started: 0, completed: 0, exported: 0, last: null };
    }
    var bucket = state.tools[toolSlug];
    if (eventType === 'tool_opened') bucket.opened += 1;
    if (eventType === 'file_uploaded') bucket.uploaded += 1;
    if (eventType === 'process_started') bucket.started += 1;
    if (eventType === 'process_completed') bucket.completed += 1;
    if (eventType === 'export_completed') bucket.exported += 1;
    bucket.last = payload.created_at;
    state.lastAt = payload.created_at;
    state.lastSlug = toolSlug;
    state.total = (state.total || 0) + 1;
    saveState(state);

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('lmx_tool_usage', payload);
      }
    } catch (e) {}

    document.dispatchEvent(new CustomEvent('lmx:tool-usage', { detail: payload }));
  }

  var slug = currentToolSlug();
  if (slug) {
    publish('tool_opened', slug);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.type !== 'file') return;
    publish('file_uploaded', slug || currentToolSlug(), 'file_selected');
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.hub-btn-primary, a[href*="/pages/"]');
    if (link && link.classList.contains('hub-btn-primary')) {
      var card = link.closest('[data-tool-id]');
      if (card) publish('tool_opened', card.getAttribute('data-tool-id'));
      return;
    }
    var btn = event.target.closest('button, a, [role="button"]');
    if (!btn || !slug) return;
    var label = ((btn.textContent || '') + ' ' + (btn.getAttribute('aria-label') || '')).toLowerCase();
    if (/descarg|export|guardar|save|download/.test(label)) {
      publish('export_completed', slug);
    } else if (/proces|gener|convert|aplicar|iniciar|mejorar|vector|quitar fondo|render/.test(label)) {
      publish('process_started', slug);
    }
  });

  window.LMXToolTracking = {
    publish: publish,
    currentToolSlug: currentToolSlug,
    loadState: loadState
  };
})();
  } catch(e) { console.error(e); }
})();

})();
